import { useEffect, useState } from 'react';

const SHEET_URL = process.env.REACT_APP_SHEET_URL || 'https://script.google.com/macros/s/AKfycbyOir1JPMoVs1WBttOZhwBMB0xuuY4J_tiG39XpSdSzZ8CJp7anTvRYSfZjAF1s60bZ/exec';


const comparisonRows = [
  {
    metric: 'Corrosion Resistance',
    smc: 'Corrosion-Free',
    smcCheck: true,
    rcc: 'High Algae & Corrosion',
    steel: 'Heavy Rusting Risk',
    plastic: 'Low UV Stability',
  },
  {
    metric: 'Maintenance Cost',
    smc: 'Extremely Low',
    smcCheck: true,
    rcc: 'High (Cracking Repair)',
    steel: 'High (Regular Painting)',
    plastic: 'Moderate Splitting Risk',
  },
  {
    metric: 'Lifespan',
    smc: '50+ Years',
    smcCheck: true,
    rcc: '15 - 20 Years',
    steel: '10 - 15 Years',
    plastic: '5 - 8 Years',
  },
  {
    metric: 'Installation Time',
    smc: '10 - 15 Days',
    smcCheck: true,
    rcc: '90+ Days (Months)',
    steel: '30 - 45 Days (Weeks)',
    plastic: 'Days (Limited Sizing)',
  },
];


const caseStudies = [
  {
    project: "Indira Gandhi International Airport, New Delhi",
    client: "Indira Gandhi International Airport (GMR Group)",
    capacity: "135 KL + 1,575 KL + 1,584 KL (Total 3,294 KL)",
    challenge: "India's busiest airport required large-scale, high-capacity water storage meeting LEED sustainability standards, with multiple phased installations across the airport's expanding infrastructure.",
    whySMC: "SMC Panel Tanks provided the modular scalability, corrosion resistance, and compliance with international safety and hygiene standards required for GMR Group's LEED-certified airport operations.",
    result: "Three high-capacity tanks totalling 3,294 KL installed across two phases. The latest order — two tanks of 1,575 KL and 1,584 KL — is the largest SMC panel tank installation at any airport in India.",
    image: "/projects/indira-gandhi-airport-delhi.jpg"
  },
  {
    project: "Kempegowda International Airport, Bengaluru",
    client: "Kempegowda International Airport (GMR Group)",
    capacity: "576 KL + 576 KL + 216 KL (Total 1,368 KL)",
    challenge: "A major international airport required high-capacity, durable, and low-maintenance water storage solutions capable of reliably supporting large-scale airport operations.",
    whySMC: "SMC Panel Tanks offered the durability, corrosion resistance, modular scalability, and compliance with international safety and hygiene standards essential for airport-scale infrastructure.",
    result: "Three SMC Panel Tanks with a combined capacity of 1,368 KL successfully installed, ensuring efficient and reliable water storage for the airport's day-to-day operations.",
    image: "/projects/kempegowda-airport-bengaluru.jpg"
  },
  {
    project: "Supreme Court of India, Delhi",
    client: "Government of India / CPWD",
    capacity: "500,000 Litres",
    challenge: "A secure national building requiring premium water hygiene and high load limits on historical foundations.",
    whySMC: "Food-grade, WRAS-approved modular panels. Extremely high strength-to-weight ratio compared to heavy RCC concrete tanks.",
    result: "Replaced old heavy steel tanks with lightweight modular tanks, preventing structure stress and providing pure, safe potable water.",
    image: "/projects/supreme-court-of-india-delhi.jpg"
  },
  {
    project: "Rashtrapati Bhawan, New Delhi",
    client: "President's Estate",
    capacity: "8,000 L + 6,000 L + 6,000 L (Total 20,000 L across 5 tanks)",
    challenge: "India's most prestigious heritage property required non-invasive, hygienic, and durable water storage with zero structural modification to the historic grounds.",
    whySMC: "Non-Insulated SMC Panel Tanks provided food-grade hygiene, corrosion-free performance, and a modular design that could be assembled without any structural alterations to the heritage property.",
    result: "Three repeat orders across multiple phases — two 4,000 L tanks, then two 3,000 L tanks, then a 6,000 L tank — reflecting Rashtrapati Bhawan's growing trust in Sovisy India.",
    image: "/projects/rashtrapati-bhawan-delhi.jpg"
  },
  {
    project: "Indian Railways Terminal, Kolkata",
    client: "CPWD / Indian Railways",
    capacity: "750,000 Litres",
    challenge: "Severe environmental vibration from rail traffic and heavy industrial smog causing rapid rusting in conventional steel storage tanks.",
    whySMC: "Corrosion-free, vibration-dampened panel design that does not fatigue, crack, or rust under train traffic vibrations.",
    result: "Zero water leakage and a projected service lifespan of 50+ years, reducing operational downtime and cleaning costs by 95%.",
    image: "/projects/cpwd-andrews-ganj-delhi.jpeg"
  }
];
function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  
  // Contact form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    company: '',
    projectType: ''
  });
  const [formStatus, setFormStatus] = useState('idle');

  // New States for LinkedIn landing page features
  const [activeCaseStudyIndex, setActiveCaseStudyIndex] = useState(0);
  const [downloadModal, setDownloadModal] = useState({ isOpen: false, title: '', fileUrl: '' });
  const [modalFormData, setModalFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    projectType: ''
  });
  const [modalFormStatus, setModalFormStatus] = useState('idle');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleHeroFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('submitting');
    try {
      const params = new URLSearchParams({ ...formData, formSource: 'Hero Form' });
      await fetch(`${SHEET_URL}?${params}`, { method: 'GET', mode: 'no-cors' });
      setFormStatus('success');
      setFormData({ name: '', email: '', phone: '', city: '', company: '', projectType: '' });
    } catch (err) {
      console.error(err);
      setFormStatus('error');
    }
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('submitting');
    try {
      const params = new URLSearchParams({ ...formData, formSource: 'Contact Form' });
      await fetch(`${SHEET_URL}?${params}`, { method: 'GET', mode: 'no-cors' });
      setFormStatus('success');
      setFormData({ name: '', email: '', phone: '', city: '', company: '', projectType: '' });
    } catch (err) {
      console.error(err);
      setFormStatus('error');
    }
  };

  const handleModalFormSubmit = async (e) => {
    e.preventDefault();
    setModalFormStatus('submitting');
    try {
      const params = new URLSearchParams({ ...modalFormData, formSource: `Download: ${downloadModal.title}` });
      await fetch(`${SHEET_URL}?${params}`, { method: 'GET', mode: 'no-cors' });
      setModalFormStatus('success');
      const link = document.createElement('a');
      link.href = downloadModal.fileUrl;
      link.setAttribute('download', downloadModal.fileUrl.split('/').pop());
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        setDownloadModal({ isOpen: false, title: '', fileUrl: '' });
        setModalFormStatus('idle');
        setModalFormData({ name: '', email: '', phone: '', company: '', projectType: '' });
      }, 2000);
    } catch (err) {
      console.error(err);
      setModalFormStatus('error');
    }
  };

  return (
    <div className="bg-background text-on-surface font-body-md overflow-x-hidden min-h-screen">
      
      {/* 🔷 TOP HEADER NAVIGATION */}
      <header className={`fixed top-0 w-full z-50 bg-surface border-b border-outline-variant transition-all duration-300 ${isScrolled ? 'technical-shadow' : ''}`}>
        <div className="flex justify-between items-center h-20 px-margin-mobile md:px-margin-desktop max-w-container-max mx-auto">
          <div className="flex items-center gap-3">
            <a href="#home" className="flex items-center gap-3 hover:opacity-90 transition-opacity" aria-label="SOVISY home">
              <img
                src={`${process.env.PUBLIC_URL}/logo.png`}
                alt="SOVISY logo"
                className="h-14 w-14 md:h-16 md:w-16 object-contain shrink-0"
              />
              <div className="hidden sm:flex flex-col justify-center">
                <div className="border-b-[3px] border-lipstick-red-500 pb-0.5 leading-none">
                  <span className="font-display-lg text-[22px] md:text-[24px] text-primary tracking-[0.22em] uppercase font-bold">
                    SOVISY
                  </span>
                </div>
                <span className="font-label-caps text-[9px] text-on-surface-variant tracking-[0.22em] mt-1 font-bold">
                  SMC &amp; GRP PANEL TANKS
                </span>
              </div>
            </a>
          </div>
          <nav className="hidden lg:flex items-center gap-8">
            <a className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors pb-1 border-b-2 border-transparent hover:border-primary" href="#home">
              HOME
            </a>
            <a className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors pb-1 border-b-2 border-transparent hover:border-primary" href="#why-consultants">
              WHY SOVISY
            </a>
            <a className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors pb-1 border-b-2 border-transparent hover:border-primary" href="#airport-projects">
              AIRPORTS
            </a>
            <a className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors pb-1 border-b-2 border-transparent hover:border-primary" href="#certifications">
              CERTIFICATIONS
            </a>
            <a className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors pb-1 border-b-2 border-transparent hover:border-primary" href="#case-studies">
              CASE STUDIES
            </a>
            <a className="font-label-caps text-label-caps text-on-surface-variant hover:text-primary transition-colors pb-1 border-b-2 border-transparent hover:border-primary" href="#comparison">
              COMPARISON
            </a>
          </nav>
          <a
            href="#contact"
            className="bg-primary text-on-primary px-5 py-3 font-label-caps text-[11px] hover:opacity-80 transition-opacity tracking-wider font-bold"
          >
            REQUEST A QUOTE
          </a>
        </div>
      </header>

      <main className="pt-20" id="home">
        
        {/* 🔷 SECTION 1: HERO SECTION + LEAD FORM */}
        <section className="relative min-h-[90vh] flex flex-col xl:flex-row items-center bg-surface-container-lowest overflow-hidden py-12 xl:py-0">
          
          {/* Left Column: B2B Value Proposition */}
          <div className="w-full xl:w-7/12 flex flex-col justify-center px-margin-mobile md:px-margin-desktop z-10">
            <div className="flex flex-wrap gap-2 mb-6">
              <span className="bg-secondary-fixed text-on-secondary-fixed-variant px-3 py-1 font-label-caps text-[10px] rounded-lg border border-secondary-container font-semibold">
                ✔ 6000+ INSTALLATIONS NATIONWIDE
              </span>
              <span className="bg-secondary-fixed text-on-secondary-fixed-variant px-3 py-1 font-label-caps text-[10px] rounded-lg border border-secondary-container font-semibold">
                ✔ CPWD, BIAL, &amp; MILITARY ENGINEERING SPECIFIED
              </span>
            </div>
            
            <h1 className="font-display-lg text-[32px] md:text-[48px] xl:text-[54px] text-on-background mb-4 leading-tight font-extrabold">
              India's Trusted SMC/GRP Panel Tank Manufacturer
            </h1>
            
            <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mb-6">
              Installed at Airports, Government Projects, Railways and Leading Industrial Facilities. 
              Engineering maintenance-free, hygienic, and scalable modular storage systems since 2012.
            </p>
            
            {/* Trust Badges Bar */}
            <div className="border-t border-b border-outline-variant py-4 mb-8 flex flex-col sm:flex-row items-start sm:items-center gap-6 w-full">
              <span className="font-label-caps text-[11px] tracking-[0.2em] text-on-surface-variant font-bold">
                GLOBAL QUALITY CERTIFICATIONS:
              </span>
              <div className="flex flex-wrap gap-4 text-xs font-bold text-primary tracking-wider">
                <span className="bg-surface-container-high px-3 py-1.5 border border-outline-variant">WRAS Approved</span>
                <span className="bg-surface-container-high px-3 py-1.5 border border-outline-variant">NSF/ANSI 61</span>
                <span className="bg-surface-container-high px-3 py-1.5 border border-outline-variant">ISO 9001</span>
                <span className="bg-surface-container-high px-3 py-1.5 border border-outline-variant">GreenPro Certified</span>
              </div>
            </div>

            {/* LinkedIn Specific Lead Magnets / Technical Resources */}
            <div className="mb-8 w-full">
              <h4 className="font-label-caps text-xs font-bold text-secondary mb-3 tracking-widest text-left">
                TECHNICAL RESOURCES FOR SPECIFIERS &amp; PMCs:
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <button
                  type="button"
                  onClick={() => setDownloadModal({ isOpen: true, title: 'Download Catalogue', fileUrl: '/catalog.pdf' })}
                  className="bg-surface border border-outline hover:border-primary p-3 text-left transition-all flex flex-col justify-between group cursor-pointer"
                >
                  <span className="text-[11px] font-bold text-on-surface opacity-75">OPTION 01</span>
                  <span className="font-headline-sm text-sm font-bold group-hover:text-primary mt-1 flex items-center justify-between">
                    Download Catalogue
                    <span className="material-symbols-outlined text-[18px]">download</span>
                  </span>
                </button>
                <button
                  type="button"
                  onClick={() => setDownloadModal({ isOpen: true, title: 'Download Airport Project Portfolio', fileUrl: '/airport_portfolio.pdf' })}
                  className="bg-surface border border-outline hover:border-primary p-3 text-left transition-all flex flex-col justify-between group cursor-pointer"
                >
                  <span className="text-[11px] font-bold text-on-surface opacity-75">OPTION 02</span>
                  <span className="font-headline-sm text-sm font-bold group-hover:text-primary mt-1 flex items-center justify-between">
                    Airport Portfolio
                    <span className="material-symbols-outlined text-[18px]">download</span>
                  </span>
                </button>
                <button
                  type="button"
                  onClick={() => setDownloadModal({ isOpen: true, title: 'Download SMC vs RCC Comparison Guide', fileUrl: '/smc_vs_rcc_guide.pdf' })}
                  className="bg-surface border border-outline hover:border-primary p-3 text-left transition-all flex flex-col justify-between group"
                >
                  <span className="text-[11px] font-bold text-on-surface opacity-75">OPTION 03</span>
                  <span className="font-headline-sm text-sm font-bold group-hover:text-primary mt-1 flex items-center justify-between">
                    SMC vs RCC Guide
                    <span className="material-symbols-outlined text-[18px]">download</span>
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* Right Column: Lead Capture Form */}
          <div className="w-full xl:w-5/12 px-margin-mobile xl:px-margin-desktop z-10 mt-8 xl:mt-0">
            <div className="bg-surface border border-outline-variant p-8 rounded-lg shadow-xl relative max-w-lg mx-auto">
              <h3 className="font-headline-sm text-xl font-bold mb-4 text-left">Request a Technical Proposal</h3>
              <p className="text-xs text-on-surface-variant mb-6 text-left">
                Receive customized calculations, spec sheets, and preliminary pricing for your upcoming BOQ.
              </p>

              <form onSubmit={handleHeroFormSubmit} className="space-y-4 text-left">
                <div>
                  <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1.5" htmlFor="hero-name">FULL NAME *</label>
                  <input
                    type="text"
                    id="hero-name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                    placeholder="Enter full name"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4 text-left">
                  <div>
                    <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1.5" htmlFor="hero-phone">PHONE NUMBER *</label>
                    <input
                      type="tel"
                      id="hero-phone"
                      required
                      pattern="[+]?[0-9\s\-]{10,15}"
                      title="Enter a valid phone number (10–15 digits)"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                      placeholder="+91 XXXXX XXXXX"
                    />
                  </div>
                  <div>
                    <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1.5" htmlFor="hero-email">EMAIL ADDRESS *</label>
                    <input
                      type="email"
                      id="hero-email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                      placeholder="work@company.com"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 text-left">
                  <div>
                    <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1.5" htmlFor="hero-company">COMPANY *</label>
                    <input
                      type="text"
                      id="hero-company"
                      required
                      value={formData.company}
                      onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                      className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                      placeholder="Company/Consultancy"
                    />
                  </div>
                  <div>
                    <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1.5" htmlFor="hero-project-type">PROJECT ROLE *</label>
                    <select
                      id="hero-project-type"
                      required
                      value={formData.projectType}
                      onChange={(e) => setFormData({ ...formData, projectType: e.target.value })}
                      className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                    >
                      <option value="" disabled>Select your role</option>
                      <option value="Consultant">Consultant</option>
                      <option value="Contractor">Contractor (MEP/EPC)</option>
                      <option value="Builder">Builder / Developer</option>
                      <option value="Government">Government Decision Maker</option>
                      <option value="Industry">Industrial/Corporate Client</option>
                      <option value="Hotel">Hotel Operator</option>
                      <option value="Hospital">Hospital Authority</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1.5" htmlFor="hero-city">PROJECT LOCATION (CITY) *</label>
                  <input
                    type="text"
                    id="hero-city"
                    required
                    value={formData.city}
                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                    className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                    placeholder="e.g. Mumbai, New Delhi"
                  />
                </div>

                <button
                  type="submit"
                  disabled={formStatus === 'submitting'}
                  className="w-full bg-primary text-on-primary py-3 font-label-caps text-[11px] tracking-widest hover:opacity-95 transition-all font-bold disabled:opacity-50 flex items-center justify-center gap-2 cursor-pointer"
                >
                  {formStatus === 'submitting' ? 'SUBMITTING...' : 'REQUEST PROPOSAL'}
                </button>

                {formStatus === 'success' && (
                  <div className="text-secondary text-center font-bold text-xs mt-2 flex items-center justify-center gap-1">
                    <span className="material-symbols-outlined text-[16px]">check_circle</span>
                    Proposal request received. Our engineers will contact you within 4 hours.
                  </div>
                )}
              </form>
            </div>
          </div>
        </section>

        {/* 🔷 SECTION 2: WHY LEADING PROJECTS CHOOSE SOVISY */}
        <section className="py-20 bg-surface-container" id="why-consultants">
          <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop">
            <div className="text-center mb-16">
              <span className="text-secondary font-label-caps text-xs block tracking-[0.2em] mb-2 font-bold">SPECIFICATION ADVANTAGE</span>
              <h2 className="font-headline-md text-3xl font-bold">Why Consultants Choose Sovisy in BOQs</h2>
              <p className="text-on-surface-variant max-w-2xl mx-auto mt-2">
                We manufacture to global B2B standards, ensuring safety, installation speed, and long-term durability.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-surface border border-outline-variant p-8 rounded hover:border-secondary hover:technical-shadow transition-all text-left">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-6">
                  <span className="material-symbols-outlined text-3xl">precision_manufacturing</span>
                </div>
                <h4 className="font-headline-sm text-lg font-bold mb-3">In-House SMC Manufacturing</h4>
                <p className="font-body-sm text-sm text-on-surface-variant leading-relaxed">
                  We control raw composite sheet formulations in-house. No sub-contracting ensures absolute material consistency and durability.
                </p>
              </div>

              <div className="bg-surface border border-outline-variant p-8 rounded hover:border-secondary hover:technical-shadow transition-all text-left">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-6">
                  <span className="material-symbols-outlined text-3xl">build_circle</span>
                </div>
                <h4 className="font-headline-sm text-lg font-bold mb-3">Complete In-House Fabrication</h4>
                <p className="font-body-sm text-sm text-on-surface-variant leading-relaxed">
                  Using state-of-the-art hydraulic compression molding and robotic trimming for panel alignment, ensuring zero-error structural assembly.
                </p>
              </div>

              <div className="bg-surface border border-outline-variant p-8 rounded hover:border-secondary hover:technical-shadow transition-all text-left">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-6">
                  <span className="material-symbols-outlined text-3xl">workspace_premium</span>
                </div>
                <h4 className="font-headline-sm text-lg font-bold mb-3">WRAS &amp; NSF Certified</h4>
                <p className="font-body-sm text-sm text-on-surface-variant leading-relaxed">
                  Fully verified non-toxic panel structure safe for high-hygiene pharmaceutical, commercial, and household potable drinking water.
                </p>
              </div>

              <div className="bg-surface border border-outline-variant p-8 rounded hover:border-secondary hover:technical-shadow transition-all text-left">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-6">
                  <span className="material-symbols-outlined text-3xl">domain</span>
                </div>
                <h4 className="font-headline-sm text-lg font-bold mb-3">Large Project Capability</h4>
                <p className="font-body-sm text-sm text-on-surface-variant leading-relaxed">
                  Proven capacity to conceptualize, fabricate, and install modular tanks exceeding 1.5 Million Litres in a single configuration.
                </p>
              </div>

              <div className="bg-surface border border-outline-variant p-8 rounded hover:border-secondary hover:technical-shadow transition-all text-left">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-6">
                  <span className="material-symbols-outlined text-3xl">flight_takeoff</span>
                </div>
                <h4 className="font-headline-sm text-lg font-bold mb-3">Airport &amp; Govt Experience</h4>
                <p className="font-body-sm text-sm text-on-surface-variant leading-relaxed">
                  Specified and approved in national hubs like Delhi and Bangalore Airports, Rashtrapati Bhavan, CPWD and Indian Railways.
                </p>
              </div>

              <div className="bg-surface border border-outline-variant p-8 rounded hover:border-secondary hover:technical-shadow transition-all text-left">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-6">
                  <span className="material-symbols-outlined text-3xl">local_shipping</span>
                </div>
                <h4 className="font-headline-sm text-lg font-bold mb-3">Nationwide Installation Teams</h4>
                <p className="font-body-sm text-sm text-on-surface-variant leading-relaxed">
                  Dedicated engineers and installation crews deploy directly to your site anywhere in India, ensuring prompt delivery and commissioning.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 🔷 SECTION 3: AIRPORT PROJECTS SHOWCASE */}
        <section className="py-20 bg-surface" id="airport-projects">
          <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop">
            <div className="text-center mb-16">
              <span className="text-secondary font-label-caps text-xs block tracking-[0.2em] mb-2 font-bold">TRUSTED BY AVIATION HUBS</span>
              <h2 className="font-headline-md text-3xl font-bold">Our Landmark Airport Deployments</h2>
              <p className="text-on-surface-variant max-w-2xl mx-auto mt-2">
                Airports require the highest standards of safety, thermal stability, and speed of installation. Sovisy stands specified.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 text-left">
              {/* Delhi Airport Card */}
              <div className="bg-surface border border-outline-variant overflow-hidden shadow-lg group">
                <div className="relative h-72 overflow-hidden bg-surface-container-high">
                  <img
                    src="/projects/indira-gandhi-airport-delhi.jpg"
                    alt="Delhi Indira Gandhi International Airport T3 SMC Tank Installation"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent flex flex-col justify-end p-6">
                    <span className="text-lipstick-red-500 font-label-caps text-[10px] font-bold tracking-widest">LANDMARK INSTALLATION</span>
                    <h3 className="text-white font-headline-sm text-2xl font-bold mt-1">Indira Gandhi International Airport, New Delhi</h3>
                  </div>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-3 gap-4 border-b border-outline-variant pb-4 mb-4 text-center">
                    <div>
                      <span className="text-[10px] font-label-caps text-on-surface-variant block font-bold">TOTAL CAPACITY</span>
                      <span className="text-primary font-bold text-lg">3,294 KL</span>
                    </div>
                    <div className="border-x border-outline-variant">
                      <span className="text-[10px] font-label-caps text-on-surface-variant block font-bold">OPERATOR</span>
                      <span className="text-primary font-bold text-sm">GMR Group</span>
                    </div>
                    <div>
                      <span className="text-[10px] font-label-caps text-on-surface-variant block font-bold">TANK TYPE</span>
                      <span className="text-primary font-bold text-sm">Non-Insulated SMC</span>
                    </div>
                  </div>
                  <p className="font-body-sm text-sm text-on-surface-variant leading-relaxed">
                    Three SMC Panel Tanks installed across two phases: 135 KL (first order) followed by 1,575 KL and 1,584 KL — the largest SMC panel tank installation at any airport in India. Compliant with GMR Group's LEED sustainability standards.
                  </p>
                </div>
              </div>

              {/* Bangalore Airport Card */}
              <div className="bg-surface border border-outline-variant overflow-hidden shadow-lg group">
                <div className="relative h-72 overflow-hidden bg-surface-container-high">
                  <img
                    src="/projects/kempegowda-airport-bengaluru.jpg"
                    alt="Kempegowda International Airport Bengaluru T2 GRP Insulated Tank Installation"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent flex flex-col justify-end p-6">
                    <span className="text-lipstick-red-500 font-label-caps text-[10px] font-bold tracking-widest">GMR GROUP PROJECT</span>
                    <h3 className="text-white font-headline-sm text-2xl font-bold mt-1">Kempegowda International Airport, Bengaluru</h3>
                  </div>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-3 gap-4 border-b border-outline-variant pb-4 mb-4 text-center">
                    <div>
                      <span className="text-[10px] font-label-caps text-on-surface-variant block font-bold">TOTAL CAPACITY</span>
                      <span className="text-primary font-bold text-lg">1,368 KL</span>
                    </div>
                    <div className="border-x border-outline-variant">
                      <span className="text-[10px] font-label-caps text-on-surface-variant block font-bold">OPERATOR</span>
                      <span className="text-primary font-bold text-sm">GMR Group / BIAL</span>
                    </div>
                    <div>
                      <span className="text-[10px] font-label-caps text-on-surface-variant block font-bold">TANK TYPE</span>
                      <span className="text-primary font-bold text-xs uppercase">Non-Insulated SMC</span>
                    </div>
                  </div>
                  <p className="font-body-sm text-sm text-on-surface-variant leading-relaxed">
                    Three SMC Panel Tanks installed — two of 576 KL each and one of 216 KL — providing a combined 1,368 KL of reliable water storage to support the airport's day-to-day operations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 🔷 SECTION 4: CERTIFICATIONS SHOWCASE */}
        <section className="py-20 bg-surface-container-high" id="certifications">
          <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop text-center">
            <span className="text-secondary font-label-caps text-xs block tracking-[0.2em] mb-2 font-bold">CREDIBILITY ENGINE</span>
            <h2 className="font-headline-md text-3xl font-bold mb-4">Third-Party Verified Approvals</h2>
            <p className="text-on-surface-variant max-w-xl mx-auto mb-12">
              Sovisy tanks undergo rigorous testing to comply with international specifications for design, safety, and hygiene.
            </p>

            <div className="grid grid-cols-2 md:grid-cols-5 gap-6 max-w-4xl mx-auto font-body-sm">
              <div className="bg-surface border border-outline-variant p-6 rounded flex flex-col items-center">
                <span className="material-symbols-outlined text-4xl text-primary mb-3">verified_user</span>
                <h4 className="font-bold text-base text-primary">WRAS</h4>
                <p className="text-[11px] text-on-surface-variant mt-1 leading-snug">UK Water Regulations certified for potable storage.</p>
              </div>

              <div className="bg-surface border border-outline-variant p-6 rounded flex flex-col items-center">
                <span className="material-symbols-outlined text-4xl text-primary mb-3">gpp_maybe</span>
                <h4 className="font-bold text-base text-primary">NSF 61</h4>
                <p className="text-[11px] text-on-surface-variant mt-1 leading-snug">Global Standard compliance for drinking water safety.</p>
              </div>

              <div className="bg-surface border border-outline-variant p-6 rounded flex flex-col items-center">
                <span className="material-symbols-outlined text-4xl text-primary mb-3">verified</span>
                <h4 className="font-bold text-base text-primary">GreenPro</h4>
                <p className="text-[11px] text-on-surface-variant mt-1 leading-snug">CII certified eco-friendly manufacturing credentials.</p>
              </div>

              <div className="bg-surface border border-outline-variant p-6 rounded flex flex-col items-center">
                <span className="material-symbols-outlined text-4xl text-primary mb-3">analytics</span>
                <h4 className="font-bold text-base text-primary">ISO 9001</h4>
                <p className="text-[11px] text-on-surface-variant mt-1 leading-snug">Certified Quality Management Systems.</p>
              </div>

              <div className="bg-surface border border-outline-variant p-6 rounded flex flex-col items-center col-span-2 md:col-span-1 mx-auto w-full">
                <span className="material-symbols-outlined text-4xl text-primary mb-3">assignment_turned_in</span>
                <h4 className="font-bold text-base text-primary">BV</h4>
                <p className="text-[11px] text-on-surface-variant mt-1 leading-snug">Bureau Veritas certified structural safety calculations.</p>
              </div>
            </div>
          </div>
        </section>

        {/* 🔷 SECTION 5: TECHNICAL VIDEO PRESENTATION */}
        <section className="py-20 bg-surface">
          <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop text-center">
            <span className="text-secondary font-label-caps text-xs block tracking-[0.2em] mb-2 font-bold">ENGINEERING PROCESS</span>
            <h2 className="font-headline-md text-3xl font-bold mb-8">Technical demonstration of SMC Panel Assembly</h2>
            
            <div className="max-w-4xl mx-auto border border-outline-variant p-4 bg-surface-container technical-shadow rounded-lg">
              <div className="relative aspect-video w-full overflow-hidden rounded">
                <iframe
                  title="Learn About SMC Tanks - Technical Video Presentation"
                  src="https://www.youtube.com/embed/HsIZaAkDtNs"
                  className="absolute inset-0 w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-4 text-left">
                <p className="font-body-sm text-xs text-on-surface-variant">
                  Take a structural tour of our panel joint sealants, hot-pressed molding process, and internal tie-rod structures.
                </p>
                <a
                  href="#contact"
                  className="bg-secondary text-on-secondary px-6 py-2.5 font-label-caps text-[10px] tracking-wider font-bold whitespace-nowrap hover:opacity-90"
                >
                  REQUEST SAMPLE DRAWING
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* 🔷 SECTION 6: DETAILED CASE STUDIES (With tabs) */}
        <section className="py-20 bg-surface-container" id="case-studies">
          <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop">
            <div className="text-center mb-12">
              <span className="text-secondary font-label-caps text-xs block tracking-[0.2em] mb-2 font-bold">DETAILED PROOFS</span>
              <h2 className="font-headline-md text-3xl font-bold">Case Studies &amp; Projects</h2>
              <p className="text-on-surface-variant max-w-xl mx-auto mt-2">
                Detailed breakdowns of complex water storage parameters resolved by our engineering teams.
              </p>
            </div>

            {/* Case Study Tabs */}
            <div className="flex flex-wrap justify-center border-b border-outline-variant mb-12 font-bold font-label-caps text-[11px]">
              {caseStudies.map((cs, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveCaseStudyIndex(idx)}
                  className={`px-6 py-4 border-b-2 transition-all uppercase tracking-wider ${activeCaseStudyIndex === idx ? 'border-primary text-primary bg-surface' : 'border-transparent text-on-surface-variant hover:text-primary'} cursor-pointer`}
                >
                  {idx === 0 ? "Delhi Airport" : idx === 1 ? "Bangalore Airport" : idx === 2 ? "Supreme Court" : idx === 3 ? "Rashtrapati Bhavan" : "Indian Railways"}
                </button>
              ))}
            </div>

            {/* Case Study Content */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 bg-surface border border-outline-variant p-8 shadow-md">
              <div className="lg:col-span-5 h-[320px] md:h-[400px] overflow-hidden bg-surface-container-high border border-outline-variant">
                <img
                  src={caseStudies[activeCaseStudyIndex].image}
                  alt={caseStudies[activeCaseStudyIndex].project}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="lg:col-span-7 flex flex-col justify-between text-left">
                <div>
                  <div className="flex justify-between items-center border-b border-outline-variant pb-4 mb-6">
                    <h3 className="font-headline-md text-xl md:text-2xl font-bold text-primary">
                      {caseStudies[activeCaseStudyIndex].project}
                    </h3>
                  </div>

                  <div className="space-y-4 font-body-sm text-sm">
                    <div>
                      <span className="font-bold text-on-surface block text-[11px] font-label-caps tracking-widest text-secondary mb-1">CLIENT / AUTHORITY</span>
                      <p className="text-on-surface-variant">{caseStudies[activeCaseStudyIndex].client}</p>
                    </div>
                    <div>
                      <span className="font-bold text-on-surface block text-[11px] font-label-caps tracking-widest text-secondary mb-1">STORAGE CAPACITY</span>
                      <p className="text-on-surface font-bold text-base">{caseStudies[activeCaseStudyIndex].capacity}</p>
                    </div>
                    <div>
                      <span className="font-bold text-on-surface block text-[11px] font-label-caps tracking-widest text-secondary mb-1">THE STRUCTURAL CHALLENGE</span>
                      <p className="text-on-surface-variant leading-relaxed">{caseStudies[activeCaseStudyIndex].challenge}</p>
                    </div>
                    <div>
                      <span className="font-bold text-on-surface block text-[11px] font-label-caps tracking-widest text-secondary mb-1">WHY MODULAR SMC WAS CHOSEN</span>
                      <p className="text-on-surface-variant leading-relaxed">{caseStudies[activeCaseStudyIndex].whySMC}</p>
                    </div>
                    <div>
                      <span className="font-bold text-on-surface block text-[11px] font-label-caps tracking-widest text-secondary mb-1">FINAL DEPLOYMENT RESULT</span>
                      <p className="text-on-surface-variant leading-relaxed">{caseStudies[activeCaseStudyIndex].result}</p>
                    </div>
                  </div>
                </div>

                <div className="mt-8 border-t border-outline-variant pt-6">
                  <a
                    href="#contact"
                    className="inline-flex items-center gap-2 bg-primary text-on-primary px-6 py-3 font-label-caps text-[11px] tracking-wider font-bold hover:opacity-90"
                  >
                    DISCUSS A SIMILAR PROJECT
                    <span className="material-symbols-outlined text-[16px]">arrow_forward</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 🔷 SECTION 7: SMC VS RCC COMPARISON SECTION */}
        <section className="py-20 px-margin-mobile md:px-margin-desktop max-w-container-max mx-auto" id="comparison">
          <div className="text-center mb-16">
            <span className="text-secondary font-label-caps text-xs block tracking-[0.2em] mb-2 font-bold">TECHNICAL SELECTION</span>
            <h2 className="font-headline-md text-3xl font-bold">Why SMC Systems Outperform RCC and Steel</h2>
            <p className="text-on-surface-variant max-w-xl mx-auto mt-2">
              Detailed engineering parameters indicating long-term operational savings and lifecycle reliability.
            </p>
          </div>
          
          <div className="overflow-x-auto border border-outline-variant shadow-lg">
            <table className="w-full text-left border-collapse bg-surface text-left">
              <thead>
                <tr className="bg-inverse-surface text-on-primary text-xs">
                  <th className="p-4 font-label-caps border border-inverse-surface">Factor</th>
                  <th className="p-4 font-label-caps border border-inverse-surface bg-primary/20 text-center text-sm font-bold text-white">SOVISY SMC / GRP PANEL TANK</th>
                  <th className="p-4 font-label-caps border border-inverse-surface">RCC (Concrete Tanks)</th>
                  <th className="p-4 font-label-caps border border-inverse-surface">Mild Steel / Galvanized</th>
                  <th className="p-4 font-label-caps border border-inverse-surface">Plastic Tanks</th>
                </tr>
              </thead>
              <tbody className="font-body-sm text-sm text-on-surface">
                {comparisonRows.map((row) => (
                  <tr className="border-b border-outline-variant hover:bg-surface-container-lowest transition-colors" key={row.metric}>
                    <td className="p-4 font-bold border-x border-outline-variant">{row.metric}</td>
                    <td className="p-4 bg-secondary-fixed/15 border-x border-outline-variant font-bold text-center">
                      <div className="flex items-center justify-center gap-2 text-secondary">
                        <span className="material-symbols-outlined text-lg" style={{ fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                        {row.smc}
                      </div>
                    </td>
                    <td className="p-4 border-x border-outline-variant text-on-surface-variant">{row.rcc}</td>
                    <td className="p-4 border-x border-outline-variant text-on-surface-variant">{row.steel}</td>
                    <td className="p-4 border-x border-outline-variant text-on-surface-variant">{row.plastic}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* 🔷 SECTION 8: BOTTOM CTA LEAD CAPTURE */}
        <section className="py-24 bg-inverse-surface text-inverse-on-surface px-margin-mobile border-t border-outline-variant" id="contact">
          <div className="max-w-container-max mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            {/* Left Column Info */}
            <div className="lg:col-span-5 text-left">
              <span className="font-label-caps text-xs text-secondary tracking-[0.3em] mb-4 block font-bold">READY TO CONFIGURE?</span>
              <h2 className="font-display-lg text-[32px] md:text-[42px] text-white mb-6 leading-tight font-extrabold">
                Get a Customized Technical Proposal
              </h2>
              <p className="font-body-lg text-inverse-on-surface/80 mb-8 leading-relaxed">
                Connect with our technical design team to review site dimensions, volume storage requirements, structural loading constraints, and custom partitioning.
              </p>
              
              <div className="space-y-6 font-body-sm">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center text-primary shrink-0">
                    <span className="material-symbols-outlined">mail</span>
                  </div>
                  <div>
                    <h5 className="font-bold text-[14px] text-white">Email Our Technical Desk</h5>
                    <a href="mailto:info@sovisy.com" className="text-secondary hover:underline">info@sovisy.com</a>
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center text-primary shrink-0">
                    <span className="material-symbols-outlined">call</span>
                  </div>
                  <div>
                    <h5 className="font-bold text-[14px] text-white">Call Engineering HQ</h5>
                    <span className="opacity-80">+91 86176 97835 / +91 93828 61855</span>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center text-primary shrink-0">
                    <span className="material-symbols-outlined">location_on</span>
                  </div>
                  <div>
                    <h5 className="font-bold text-[14px] text-white">Visit Manufacturing Plant</h5>
                    <span className="opacity-80">D. K. Industrial Estate II, Chhatral Gandhinagar, Gujarat - 382729</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column Form */}
            <div className="lg:col-span-7 bg-onyx-900 border border-outline/20 p-8 rounded-lg shadow-xl text-left">
              <h3 className="font-headline-sm text-white mb-6 text-xl font-bold">Request Technical Review</h3>
              
              <form onSubmit={handleFormSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[10px] font-label-caps text-white/80 mb-1.5" htmlFor="contact-name">FULL NAME *</label>
                    <input
                      type="text"
                      id="contact-name"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="w-full bg-onyx-950 border border-outline/35 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-primary font-body-sm"
                      placeholder="John Doe"
                    />
                  </div>
                  <div>
                    <label className="block text-[10px] font-label-caps text-white/80 mb-1.5" htmlFor="contact-email">EMAIL ADDRESS *</label>
                    <input
                      type="email"
                      id="contact-email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full bg-onyx-950 border border-outline/35 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-primary font-body-sm"
                      placeholder="john@company.com"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[10px] font-label-caps text-white/80 mb-1.5" htmlFor="contact-phone">MOBILE NUMBER *</label>
                    <input
                      type="tel"
                      id="contact-phone"
                      required
                      pattern="[+]?[0-9\s\-]{10,15}"
                      title="Enter a valid phone number (10–15 digits)"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      className="w-full bg-onyx-950 border border-outline/35 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-primary font-body-sm"
                      placeholder="+91 XXXXX XXXXX"
                    />
                  </div>
                  <div>
                    <label className="block text-[10px] font-label-caps text-white/80 mb-1.5" htmlFor="contact-city">YOUR CITY *</label>
                    <input
                      type="text"
                      id="contact-city"
                      required
                      value={formData.city}
                      onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                      className="w-full bg-onyx-950 border border-outline/35 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-primary font-body-sm"
                      placeholder="e.g. Mumbai, Chennai"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[10px] font-label-caps text-white/80 mb-1.5" htmlFor="contact-company">YOUR COMPANY *</label>
                    <input
                      type="text"
                      id="contact-company"
                      required
                      value={formData.company}
                      onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                      className="w-full bg-onyx-950 border border-outline/35 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-primary font-body-sm"
                      placeholder="Infrastructure Ltd"
                    />
                  </div>
                  <div>
                    <label className="block text-[10px] font-label-caps text-white/80 mb-1.5" htmlFor="contact-project-type">PROJECT ROLE *</label>
                    <select
                      id="contact-project-type"
                      required
                      value={formData.projectType}
                      onChange={(e) => setFormData({ ...formData, projectType: e.target.value })}
                      className="w-full bg-onyx-950 border border-outline/35 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-primary font-body-sm"
                    >
                      <option value="" disabled>Select your role</option>
                      <option value="Consultant">Consultant</option>
                      <option value="Contractor">Contractor (MEP/EPC)</option>
                      <option value="Builder">Builder / Developer</option>
                      <option value="Government">Government Decision Maker</option>
                      <option value="Industry">Industrial/Corporate Client</option>
                      <option value="Hotel">Hotel Operator</option>
                      <option value="Hospital">Hospital Authority</option>
                    </select>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row items-center gap-4 pt-2">
                  <button
                    type="submit"
                    disabled={formStatus === 'submitting'}
                    className="w-full sm:w-auto bg-primary text-on-primary px-8 py-3 font-label-caps text-[11px] tracking-widest hover:opacity-95 transition-all font-bold disabled:opacity-50 flex items-center justify-center gap-2 cursor-pointer"
                  >
                    {formStatus === 'submitting' ? 'SUBMITTING...' : 'SUBMIT REQUEST'}
                  </button>

                  {formStatus === 'success' && (
                    <div className="text-secondary font-bold text-xs flex items-center gap-2">
                      <span className="material-symbols-outlined">check_circle</span>
                      Quote request received. We will email you the details.
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>

      {/* 🔷 FOOTER */}
      <footer className="bg-primary text-on-primary border-t border-white/10">
        <div className="px-margin-mobile md:px-margin-desktop py-16 max-w-container-max mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
          
          {/* Col 1 */}
          <div className="lg:col-span-4 text-left">
            <div className="flex items-center gap-4 mb-5">
              <img
                src={`${process.env.PUBLIC_URL}/logo.png`}
                alt="SOVISY logo"
                className="h-16 w-16 object-contain shrink-0 rounded-xl bg-white/90 p-1"
              />
              <div>
                <h2 className="font-display-lg text-[28px] text-on-primary uppercase font-bold tracking-tighter">SOVISY</h2>
                <p className="font-label-caps text-[11px] tracking-[0.28em] text-on-primary/70">SMC &amp; GRP PANEL TANKS</p>
              </div>
            </div>
            <p className="font-body-sm opacity-70 leading-relaxed mb-6">
              Pioneering B2B water storage systems through precision engineering. India's premier manufacturer of advanced modular panel storage for heavy infrastructure.
            </p>
            <div className="flex flex-col gap-2 font-body-sm text-[13px] opacity-80">
              <div className="flex items-center gap-2">
                <span className="material-symbols-outlined text-[18px]">verified</span>
                <span>ISO 9001:2015 Quality Certified</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="material-symbols-outlined text-[18px]">verified</span>
                <span>WRAS Approved Component Certification</span>
              </div>
            </div>
          </div>

          {/* Col 2 */}
          <div className="lg:col-span-4 grid grid-cols-2 gap-8 text-left">
            <div>
              <h5 className="font-label-caps text-[11px] tracking-wider text-on-primary mb-4 opacity-50 font-bold font-bold">NAVIGATE</h5>
              <div className="flex flex-col gap-3 font-body-sm text-[14px]">
                <a className="opacity-80 hover:opacity-100 hover:underline" href="#home">Home</a>
                <a className="opacity-80 hover:opacity-100 hover:underline" href="#why-consultants">Why Us</a>
                <a className="opacity-80 hover:opacity-100 hover:underline" href="#airport-projects">Airports</a>
                <a className="opacity-80 hover:opacity-100 hover:underline" href="#certifications">Certifications</a>
                <a className="opacity-80 hover:opacity-100 hover:underline" href="#case-studies">Case Studies</a>
              </div>
            </div>
            <div>
              <h5 className="font-label-caps text-[11px] tracking-wider text-on-primary mb-4 opacity-50 font-bold font-bold">PRODUCTS</h5>
              <div className="flex flex-col gap-3 font-body-sm text-[14px]">
                <a className="opacity-80 hover:opacity-100 hover:underline" href="#home">SMC Panel Tanks</a>
                <a className="opacity-80 hover:opacity-100 hover:underline" href="#home">GRP Insulated Tanks</a>
                <a className="opacity-80 hover:opacity-100 hover:underline" href="#home">Custom Storage</a>
                <a className="opacity-80 hover:opacity-100 hover:underline" href="#home">Partition Tanks</a>
              </div>
            </div>
          </div>

          {/* Col 3 */}
          <div className="lg:col-span-4 text-left">
            <h5 className="font-label-caps text-[11px] tracking-wider text-on-primary mb-4 opacity-50 font-bold">HEADQUARTERS LOCATION</h5>
            <div className="w-full h-44 overflow-hidden border border-white/20 rounded mb-4">
              <iframe
                title="SOVISY GIDC Industrial Estate Headquarters Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3663.7915589088656!2d72.4542289!3d23.3233801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c25dbb2670eab%3A0x8670bf7811ef2cb3!2sGIDC%2C%20Chhatral%2C%20Gujarat%20382721!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                className="w-full h-full border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <p className="font-body-sm text-[13px] opacity-80 leading-relaxed">
              D. K. Industrial Estate II, Chhatral Gandhinagar, Gujarat - 382729, India
            </p>
          </div>
        </div>

        <div className="px-margin-mobile md:px-margin-desktop py-6 max-w-container-max mx-auto flex flex-col md:flex-row justify-between gap-4 opacity-60 font-body-sm text-[12px] border-t border-white/10">
          <p>© 2026 SOVISY INDUSTRIAL SYSTEMS. ALL RIGHTS RESERVED.</p>
          <span>DELIVERING ENGINEERING PERMANENCE NATIONWIDE</span>
        </div>
      </footer>

      {/* 🔷 DOWNLOAD RESOURCE MODAL */}
      {downloadModal.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-surface border border-outline-variant p-6 md:p-8 rounded-lg shadow-2xl max-w-md w-full relative text-left">
            <button
              onClick={() => setDownloadModal({ isOpen: false, title: '', fileUrl: '' })}
              className="absolute top-4 right-4 text-on-surface-variant hover:text-primary transition-colors cursor-pointer"
              aria-label="Close modal"
            >
              <span className="material-symbols-outlined">close</span>
            </button>

            <h3 className="font-headline-sm text-xl font-bold mb-2">Request Technical Document</h3>
            <p className="text-xs text-on-surface-variant mb-6">
              Enter your professional details below to immediately access <strong>{downloadModal.title}</strong>.
            </p>

            <form onSubmit={handleModalFormSubmit} className="space-y-4">
              <div>
                <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1" htmlFor="modal-name">FULL NAME *</label>
                <input
                  type="text"
                  id="modal-name"
                  required
                  value={modalFormData.name}
                  onChange={(e) => setModalFormData({ ...modalFormData, name: e.target.value })}
                  className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                  placeholder="Enter full name"
                />
              </div>

              <div>
                <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1" htmlFor="modal-email">WORK EMAIL *</label>
                <input
                  type="email"
                  id="modal-email"
                  required
                  value={modalFormData.email}
                  onChange={(e) => setModalFormData({ ...modalFormData, email: e.target.value })}
                  className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                  placeholder="name@company.com"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1" htmlFor="modal-phone">MOBILE NUMBER *</label>
                  <input
                    type="tel"
                    id="modal-phone"
                    required
                    pattern="[+]?[0-9\s\-]{10,15}"
                    title="Enter a valid phone number (10–15 digits)"
                    value={modalFormData.phone}
                    onChange={(e) => setModalFormData({ ...modalFormData, phone: e.target.value })}
                    className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                    placeholder="+91 XXXXX XXXXX"
                  />
                </div>
                <div>
                  <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1" htmlFor="modal-company">COMPANY *</label>
                  <input
                    type="text"
                    id="modal-company"
                    required
                    value={modalFormData.company}
                    onChange={(e) => setModalFormData({ ...modalFormData, company: e.target.value })}
                    className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                    placeholder="Company name"
                  />
                </div>
              </div>

              <div>
                <label className="block text-[10px] font-label-caps text-on-surface-variant font-bold mb-1" htmlFor="modal-project-type">PROJECT ROLE *</label>
                <select
                  id="modal-project-type"
                  required
                  value={modalFormData.projectType}
                  onChange={(e) => setModalFormData({ ...modalFormData, projectType: e.target.value })}
                  className="w-full bg-surface-container-low border border-outline-variant rounded px-3 py-2 text-sm focus:outline-none focus:border-primary font-body-sm"
                >
                  <option value="" disabled>Select your role</option>
                  <option value="Consultant">Consultant</option>
                  <option value="Contractor">Contractor (MEP/EPC)</option>
                  <option value="Builder">Builder / Developer</option>
                  <option value="Government">Government Decision Maker</option>
                  <option value="Industry">Industrial/Corporate Client</option>
                  <option value="Hotel">Hotel Operator</option>
                  <option value="Hospital">Hospital Authority</option>
                </select>
              </div>

              <button
                type="submit"
                disabled={modalFormStatus === 'submitting'}
                className="w-full bg-primary text-on-primary py-3 font-label-caps text-[11px] tracking-widest hover:opacity-95 transition-all font-bold disabled:opacity-50 flex items-center justify-center gap-2 cursor-pointer"
              >
                {modalFormStatus === 'submitting' ? 'VERIFYING...' : 'VERIFY & DOWNLOAD'}
              </button>

              {modalFormStatus === 'success' && (
                <div className="text-secondary text-center font-bold text-xs mt-2 flex items-center justify-center gap-1">
                  <span className="material-symbols-outlined text-[16px]">check_circle</span>
                  Verified! Download starting automatically.
                </div>
              )}
            </form>
          </div>
        </div>
      )}

    </div>
  );
}

export default App;
